import React from 'react';
import { useCustomItemChildProps } from "../../hooks/useCustomItemChildProps.js";
import { useReactChildProps } from "../../hooks/useReactChildProps.js";
export const DropdownChild = ({
  child,
  index,
  option,
  onSelection,
  listItemsRef,
  activeItem,
  getItemProps,
  small,
  isActiveIndex,
  highlightString,
  visible = true,
  childOfCategory = false
}) => {
  const reactProps = useReactChildProps({
    option,
    small,
    activeItem,
    isActiveIndex,
    childOfCategory
  });
  const customItemProps = useCustomItemChildProps({
    child,
    option,
    index,
    listItemsRef,
    onSelection,
    isActiveIndex,
    visible
  });
  if (! /*#__PURE__*/React.isValidElement(child)) {
    throw new Error('Invalid Dropdown childs');
  }
  return /*#__PURE__*/React.cloneElement(child, {
    ...getItemProps(customItemProps),
    ...reactProps,
    ...(option.type === 'OPTION' ? {
      highlightString
    } : {})
  });
};